import { fromUnixTime } from 'date-fns';

import { SPECIAL_DATE_RANGES } from '/src/features/_global/constants';

const VALID_AB_TEST_SPECIAL_DATE_RANGES = new Set(Object.values(SPECIAL_DATE_RANGES));
const DEFAULT_AB_TEST_DATE_SELECTION = {
  special: 'default',
  startDate: null,
  endDate: null,
};

export function getDefaultAbTestDateSelection() {
  return { ...DEFAULT_AB_TEST_DATE_SELECTION };
}

export function isValidAbTestSpecialDateRange(special) {
  return VALID_AB_TEST_SPECIAL_DATE_RANGES.has(special);
}

export function parseAbTestSelectedDateRangeParam(dateRange) {
  if (!dateRange) {
    return {
      isValid: true,
      selection: getDefaultAbTestDateSelection(),
    };
  }

  if (dateRange.includes(',')) {
    const parts = dateRange.split(',');
    if (parts.length === 2) {
      const [startDate, endDate] = parts.map(Number);

      if (Number.isFinite(startDate) && Number.isFinite(endDate)) {
        return {
          isValid: true,
          selection: {
            special: null,
            startDate,
            endDate,
          },
        };
      }
    }

    return {
      isValid: false,
      selection: getDefaultAbTestDateSelection(),
    };
  }

  if (isValidAbTestSpecialDateRange(dateRange)) {
    return {
      isValid: true,
      selection: {
        special: dateRange,
        startDate: null,
        endDate: null,
      },
    };
  }

  return {
    isValid: false,
    selection: getDefaultAbTestDateSelection(),
  };
}

export function getAbTestFeatureStartedAt(abTest) {
  return abTest?.publishedAt ?? abTest?.createdAt ?? null;
}

export function getPickerDateRange({ dateRange, getConvertedDateRange, resolverOptions }) {
  if (!dateRange) return null;

  if (dateRange.special) {
    if (!isValidAbTestSpecialDateRange(dateRange.special)) return null;

    const specialDateRange = getConvertedDateRange({ special: dateRange.special }, resolverOptions);

    if (!specialDateRange) return null;

    return {
      start_date: fromUnixTime(specialDateRange.startDate),
      end_date: fromUnixTime(specialDateRange.endDate),
    };
  }

  if (!dateRange.start_date || !dateRange.end_date) return null;

  return dateRange;
}
